import axios from 'axios';
import { APP_BASE_URL } from 'widget/helpers/constants';

export const API = axios.create({
  baseURL: window.chatwootConfig?.apiHost || APP_BASE_URL,
  withCredentials: false,
});

export const setHeader = (key, value) => {
  API.defaults.headers.common[key] = value;
};

export const removeHeader = key => {
  delete API.defaults.headers.common[key];
};

API.interceptors.request.use(config => {
  const cw_conversation = getLocalStorageItem('cw_conversation');
  const websiteToken = getLocalStorageItem('websiteToken');
  const locale = getLocalStorageItem('locale');

  config.params = {
    ...config.params,
    website_token: websiteToken || '',
    cw_conversation: cw_conversation || '',
    locale: locale || '',
  };
  return config;
}, error => {
  return Promise.reject(error);
});

const getLocalStorageItem = (key) => {
  return localStorage.getItem(key);
};